import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";

import Customers from "./pages/Customers";
import Suppliers from "./pages/Suppliers";
import Users from "./pages/Users";
import Materials from "./pages/Materials";
import SalesOrders from "./pages/SalesOrders";
import WorkOrders from "./pages/WorkOrders";
import Inventory from "./pages/Inventory";
import WipBalances from "./pages/WipBalances";
import WorkCenters from "./pages/WorkCenters";
import WorkCenterGroups from "./pages/WorkCenterGroups";
import Knives from "./pages/Knives";
import Shifts from "./pages/Shifts";
import Molds from "./pages/Molds";
import LoginPage from "./pages/LoginPage";
import SupportVariantDimensions from "./pages/SupportVariantDimensions";
import SupportVariantOptions from "./pages/SupportVariantOptions";
import SupportExcelImport from "./pages/SupportExcelImport";
import OperatorAssignedOrdersPage from "./pages/operator/OperatorAssignedOrdersPage";
import OperatorOrderReportPage from "./pages/operator/OperatorOrderReportPage";
import WorkOrderApprovalSearchPage from "./pages/admin/WorkOrderApprovalSearchPage";
import ProductionStatusReportPage from "./pages/admin/ProductionStatusReportPage";
import QualityControlApprovalsPage from "./pages/admin/QualityControlApprovalsPage";
import HammaddeHubPage from "./pages/admin/rawMaterials/HammaddeHubPage";
import PaperIntakePage from "./pages/admin/rawMaterials/PaperIntakePage";
import InkIntakePage from "./pages/admin/rawMaterials/InkIntakePage";
import LakIntakePage from "./pages/admin/rawMaterials/LakIntakePage";
import BoxIntakePage from "./pages/admin/rawMaterials/BoxIntakePage";
import ShrinkIntakePage from "./pages/admin/rawMaterials/ShrinkIntakePage";
import LabelIntakePage from "./pages/admin/rawMaterials/LabelIntakePage";
import PaperReservationsPage from "./pages/admin/PaperReservationsPage";
import WorkCenterPlanningPage from "./pages/admin/WorkCenterPlanningPage";
import FasonTakipPage from "./pages/admin/FasonTakipPage";
import ChatbotPage from "./pages/admin/ChatbotPage";
import CostReportPage from "./pages/admin/CostReportPage";
import CardsPage from "./pages/CardsPage";
import TasksPage from "./pages/TasksPage";
import DowntimeReasons from "./pages/DowntimeReasons";
import ShiftProductionEntryPage from "./pages/admin/ShiftProductionEntryPage";

function RequireAuth({ children }) {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

function RequireAdmin({ children }) {
  const token = localStorage.getItem("token");
  if (!token) return <Navigate to="/login" replace />;
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    if (user?.role !== "admin") return <Navigate to="/" replace />;
  } catch {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function HomeRedirect() {
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "null");
    } catch {
      return null;
    }
  })();
  const target =
    user?.role === "operator"
      ? "/operator/assigned"
      : user?.role === "quality"
      ? "/reports/quality-control"
      : "/sales-orders";
  return <Navigate to={target} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/"
            element={
              <RequireAuth>
                <HomeRedirect />
              </RequireAuth>
            }
          />
          <Route
            path="/customers"
            element={
              <RequireAuth>
                <Customers />
              </RequireAuth>
            }
          />
          <Route
            path="/cards"
            element={
              <RequireAuth>
                <CardsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/suppliers"
            element={
              <RequireAuth>
                <Suppliers />
              </RequireAuth>
            }
          />
          <Route
            path="/users"
            element={
              <RequireAuth>
                <Users />
              </RequireAuth>
            }
          />
          <Route
            path="/employees"
            element={
              <RequireAuth>
                <Navigate to="/users" replace />
              </RequireAuth>
            }
          />
          <Route
            path="/materials"
            element={
              <RequireAuth>
                <Materials />
              </RequireAuth>
            }
          />
          <Route
            path="/paper-reservations"
            element={
              <RequireAuth>
                <PaperReservationsPage />
              </RequireAuth>
            }
          />
          <Route
            path="/orders"
            element={
              <RequireAuth>
                <Navigate to="/sales-orders" replace />
              </RequireAuth>
            }
          />
          <Route
            path="/sales-orders"
            element={
              <RequireAuth>
                <SalesOrders />
              </RequireAuth>
            }
          />
          <Route
            path="/work-orders"
            element={
              <RequireAuth>
                <WorkOrders />
              </RequireAuth>
            }
          />
          <Route
            path="/fason-takip"
            element={
              <RequireAuth>
                <FasonTakipPage />
              </RequireAuth>
            }
          />
          <Route
            path="/tasks"
            element={
              <RequireAuth>
                <TasksPage />
              </RequireAuth>
            }
          />
          <Route
            path="/inventory"
            element={
              <RequireAuth>
                <Inventory />
              </RequireAuth>
            }
          />
          <Route
            path="/wip"
            element={
              <RequireAuth>
                <WipBalances />
              </RequireAuth>
            }
          />
          <Route
            path="/work-center-groups"
            element={
              <RequireAuth>
                <WorkCenterGroups />
              </RequireAuth>
            }
          />
          <Route
            path="/work-centers"
            element={
              <RequireAuth>
                <WorkCenters />
              </RequireAuth>
            }
          />
          <Route
            path="/knives"
            element={
              <RequireAuth>
                <Knives />
              </RequireAuth>
            }
          />
          <Route
            path="/molds"
            element={
              <RequireAuth>
                <Molds />
              </RequireAuth>
            }
          />
          <Route
            path="/shifts"
            element={
              <RequireAuth>
                <Shifts />
              </RequireAuth>
            }
          />
          <Route
            path="/downtime-reasons"
            element={
              <RequireAuth>
                <DowntimeReasons />
              </RequireAuth>
            }
          />
          <Route
            path="/production/shift-entry"
            element={
              <RequireAdmin>
                <ShiftProductionEntryPage />
              </RequireAdmin>
            }
          />
          <Route
            path="/support/variant-dimensions"
            element={
              <RequireAuth>
                <SupportVariantDimensions />
              </RequireAuth>
            }
          />
          <Route
            path="/support/variant-options"
            element={
              <RequireAuth>
                <SupportVariantOptions />
              </RequireAuth>
            }
          />
          <Route
            path="/support/excel-import"
            element={
              <RequireAuth>
                <SupportExcelImport />
              </RequireAuth>
            }
          />

          {/* Admin reports */}
          <Route
            path="/reports/work-order-approvals"
            element={
              <RequireAuth>
                <WorkOrderApprovalSearchPage />
              </RequireAuth>
            }
          />
          <Route
            path="/reports/production-status"
            element={
              <RequireAuth>
                <ProductionStatusReportPage />
              </RequireAuth>
            }
          />
          <Route
            path="/reports/quality-control"
            element={
              <RequireAuth>
                <QualityControlApprovalsPage />
              </RequireAuth>
            }
          />

          {/* Raw materials intake */}
          <Route
            path="/admin/raw-materials/hammadde"
            element={
              <RequireAuth>
                <HammaddeHubPage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/raw-materials/paper"
            element={
              <RequireAuth>
                <PaperIntakePage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/raw-materials/ink"
            element={
              <RequireAuth>
                <InkIntakePage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/raw-materials/lak"
            element={
              <RequireAuth>
                <LakIntakePage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/raw-materials/box"
            element={
              <RequireAuth>
                <BoxIntakePage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/raw-materials/shrink"
            element={
              <RequireAuth>
                <ShrinkIntakePage />
              </RequireAuth>
            }
          />
          <Route
            path="/admin/raw-materials/label"
            element={
              <RequireAuth>
                <LabelIntakePage />
              </RequireAuth>
            }
          />

          <Route
            path="/planning/work-center-queue"
            element={
              <RequireAuth>
                <WorkCenterPlanningPage />
              </RequireAuth>
            }
          />

          {/* Chatbot / Asistan */}
          <Route
            path="/chatbot"
            element={
              <RequireAuth>
                <ChatbotPage />
              </RequireAuth>
            }
          />

          {/* Fiili Maliyet */}
          <Route
            path="/cost-report"
            element={
              <RequireAuth>
                <CostReportPage />
              </RequireAuth>
            }
          />

          {/* Operator */}
          <Route
            path="/operator/assigned"
            element={
              <RequireAuth>
                <OperatorAssignedOrdersPage />
              </RequireAuth>
            }
          />
          <Route
            path="/operator/orders/:id"
            element={
              <RequireAuth>
                <OperatorOrderReportPage />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
